// extracted by mini-css-extract-plugin
export var center = "textPortraitSection-module--center--00749";
export var image = "textPortraitSection-module--image--d7f15";
export var person = "textPortraitSection-module--person--74881";
export var poste = "textPortraitSection-module--poste--55fac";
export var svg = "textPortraitSection-module--svg--0fa9b";
export var text = "textPortraitSection-module--text--35831";
export var wrapper = "textPortraitSection-module--wrapper--a58e6";
export var wrappersvg = "textPortraitSection-module--wrappersvg--65704";